import { Dispatch } from 'redux';
import { AxiosError } from 'axios';
import { loginForms } from '@app/enums';
import { IUserData, SetEmptyFieldError, SetErrorCode } from './';
import { SetIsError } from './error.model';
import { UserSessionInfo } from './session.model';

export type SetPassword = (password: string) => void;
export type SetLoginForm = (form: loginForms) => void;
export type SetUsername = (username: string) => void;
export type SetUserSessionInfo = (sessionInfo: UserSessionInfo) => void;
export type SetCredentials = (cb: (credentials: ICredentials) => ICredentials) => void;

export interface ICredentials {
    username: string;
    password: string;
}

export enum SigninResponseTypes {
    code = 'code',
    token = 'token',
    postMessage = 'post_message',
    id_token = 'id_token'
}

export interface HandleSignin {
    username: string;
    password: string;
    rememberMe?: boolean;
    setIsError: SetIsError;
    dispatch: Dispatch;
    setErrorCode: SetErrorCode;
    setEmptyUsernameError?: SetEmptyFieldError;
    setEmptyPasswordError: SetEmptyFieldError;
}

export interface HandleKaseyaOneSignin {
    username?: string;
    password?: string;
    setErrorKaseyaOneCode: SetErrorCode;
    setIsPageLoading: (is: boolean) => void;
    setIsLoading: (is: boolean) => void;
    setLoginForm: (is: loginForms) => void;
    dispatch: Dispatch;
}

export type PasswordResetType = 'mail' | 'sms' | null;

export type SetIsPasswordReset = (is: boolean) => void;
export type SetIsResetToken = (is: boolean) => void;
export type SetIsUserCanResetPassword = (is: boolean) => void;
export type SetIsUserHasRegisteredPhone = (is: boolean) => void;
export type SetUserId = (id: string) => void;
export type SetIsUserRegisteredPhone = (is: boolean) => void;
export type SetVerificationCode = (code: string) => void;
export type SetIsNeedResendCode = (is: boolean) => void;
export type SetIsCanResetByEmail = (is: boolean) => void;
export type SetIsCanResetBySms = (is: boolean) => void;
export type SetPasswordResetError = ({}) => void;

export type SetPasswordResetType = (type: PasswordResetType) => void;

export interface PswResetServerResponse {
    username: string;
    originalUsername: string;
    userId: string;
    passwordPolicy: Object;
    canChangePassword: boolean;
    hasRegisteredPhone?: boolean;
    state: number;
}

export interface UserDataPswResetBySms {
    username: string;
    resetToken: string;
    verificationCode: string;
}

export interface DataForPswResetSmsResponse {
    username: string;
    canChangePassword: boolean;
    resetRequiresVerification: boolean;
    resetToken: string;
}

export interface DataForSubmitEmailCode {
    username: string;
    canChangePassword: boolean;
    userId: string;
    passwordPolicy: any;
    resetToken: string;
    state: number;
    verificationCode: string;
}

export type SetDataForPswResetSmsResponse = (userData: DataForPswResetSmsResponse) => void;

export interface UserDataPswChange {
    username: string;
    newPassword: string;
    resetToken: string;
}

export type SetUserInfoFromServer = (info: PswResetServerResponse) => void;

export type SetIsPasswordChanged = (is: boolean) => void;
export type SetIsUserNotFound = (is: boolean) => void;
export type SetIsResendingCode = (is: boolean) => void;

export type OnSubmitUserCheck = (e: React.FormEvent<HTMLFormElement>) => void;

export type SignIn = {
    form: loginForms;
    loggingIn: boolean;
    loggedIn: boolean;
    user: string;
    token: string;
    currentUser: IUserData;
    error: AxiosError<any>;
};

export interface RegisterRequest {
    // rp: PublicKeyCredentialRpEntity;
    // user: PublicKeyCredentialUserEntity;
    // challenge: string;
    // pubKeyCredParams: PublicKeyCredentialParameters[];
    timeout: number;
    attestation: string;

    excludeCredentials: [];
    status: string;
    errorMessage: string;
}
